module.exports = __webpack_public_path__ + "static/desktop/img/calendar-2-thumb.f16c07c0.png";